var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockSettings = function SvgClockSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M27.41 15.305a12.105 12.105 0 1 0-12.107 12.106m9.419 0a2.69 2.69 0 0 1 0-5.38m0 5.38a2.69 2.69 0 1 0 0-5.38m0 5.38v2.017m0-7.398v-2.017m4.077 2.354-1.748 1.008m-4.657 2.69-1.749 1.01m0-4.708 1.749 1.008m4.657 2.69 1.749 1.01M15.305 8.58v6.725l2.69 2.69"
  })));
};
export default SvgClockSettings;